import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { MainModule } from "./app/root.module";

import { IcEnvironment } from "@intocare-medapp/environment";

const icEnvironment = new IcEnvironment();

if (icEnvironment.getEnvironment().PRODUCTION) {
	enableProdMode();
}

// @ts-expect-error TS7015
if (window["cordova"]) {
	// Wait for Cordova to load
	// https://cordova.apache.org/docs/en/11.x/cordova/events/events.html#deviceready
	document.addEventListener("deviceready", onDeviceReady, false);
} else {
	// Start Angular
	bootstrap();
}

function onDeviceReady() {
	// Start Angular, all Cordova web API's are now available
	bootstrap();
}

function bootstrap() {
	platformBrowserDynamic().bootstrapModule(MainModule);
}
